import { createContext } from 'react';

const AlertsContext = createContext({
  reloadAlerts: () => {},
});

export default AlertsContext;
